<div class="highcharts-tooltip">
  <span *ngIf="school[column.id]">
    <div>
      <span
        class="metric-tooltip title school_comp_title capitalize tile_body"
        >{{ column.title }}</span
      >
      <span
        class="metric-tooltip value school_comp_value tooltip_value"
        [ngStyle]="{ color: school[column.id].color }"
        >{{ district[column.id] ? district[column.id].overallPrefix : ""
        }}{{ school[column.id].y
        }}{{
          district[column.id] ? district[column.id].overallSuffix : ""
        }}</span
      >
    </div>
    <div>
      <span class="metric-tooltip subtitle">{{
        school[column.id] ? school[column.id]["subtitle"] : ""
      }}</span>
      <span
        class="metric-tooltip subtitle district-goal"
        *ngIf="school[column.id] && school[column.id].goal"
      >
        School goal:
        <span
          [ngStyle]="{
            color: getColor(
              school[column.id]['goaln'],
              district[column.id].upIsGood,
              school[column.id].y
            )
          }"
          >{{ school[column.id].goal }}</span
        >
      </span>
    </div>
    <div>
      <span class="metric-tooltip subtitle"></span>
      <span
        class="metric-tooltip subtitle district-goal"
        *ngIf="district[column.id] && district[column.id].goal"
      >
        District goal:
        <span
          [ngStyle]="{
            color: getColor(
              district[column.id].goalNumeric,
              district[column.id].upIsGood,
              school[column.id].y
            )
          }"
          >{{ district[column.id].goal }}</span
        >
      </span>
    </div>
    <div
      class="metric-tooltip school_comp_description body_tooltip_text"
      *ngIf="district[column.id] && district[column.id].overallSuffix"
    >
      <strong>{{ school[column.id].numerator | number }}</strong> of
      <strong>{{ school[column.id].denominator | number }}</strong>
      {{ district[column.id] ? district[column.id].descriptor : "" }}
    </div>
    <div
      class="metric-tooltip school_comp_description body_tooltip_text"
      *ngIf="!district[column.id] || !district[column.id].overallSuffix"
    >
      <strong>{{ school[column.id].numerator | number }}</strong>
      {{ district[column.id] ? district[column.id].descriptor : "" }}
    </div>
  </span>
  <span *ngIf="!school[column.id]">
    <span class="metric-tooltip title school_comp_title capitalize tile_body"
      >No data available</span
    >
    <div class="metric-tooltip school_comp_description body_tooltip_text">
      We couldn't find any data for this metric.
    </div>
  </span>
</div>
